import React from 'react';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';

const ConfirmDialog = (props) => {
  const { id, title, open, setOpen, onConfirm, content } = props;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ width: '50%' }}
          onClick={() => {
            setOpen(false);
            onConfirm(true, id);
          }} >
          Yes
        </Button>
        <Button
          variant="outlined"
          sx={{ width: '50%' }}
          onClick={() => {
            setOpen(false);
            onConfirm(false);
          }} >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;